"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../app/contexts");
require("./box-monthly-check.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const MonthlyCheckbox = _ref => {
  let {
    id,
    checked = false,
    onClick
  } = _ref;
  const {
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const inputId = `donation-encourager__monthly-check_switch-${id}`;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "donation-encourager__monthly-check"
  }, /*#__PURE__*/_react.default.createElement("span", null, strings.monthly), /*#__PURE__*/_react.default.createElement("span", {
    className: "switch"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: inputId,
    type: "checkbox",
    checked: checked,
    onChange: e => onClick(e.target.checked)
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: inputId,
    className: "donation-encourager__monthly-check-label"
  }, "Switch")));
};
function useMonthlyCheckbox(id) {
  const [isMonthly, setIsMonthly] = (0, _react.useState)(false);
  const comp = /*#__PURE__*/_react.default.createElement(MonthlyCheckbox, {
    id: id,
    checked: isMonthly,
    onClick: () => setIsMonthly(m => !m)
  });
  return [comp, isMonthly];
}
var _default = useMonthlyCheckbox;
exports.default = _default;